import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "TicketTemplate";
const json = { "Content-Type": "application/json" };
const url = (path: string) => `${environment.server.apiURL}/${endpoint}${path}`;

/** Price categories and their grids: template × area × ticket type. */
export const TicketTemplateService = {
	endpoint,
	getAll: async () => await FetchInterceptor(url(""), {headers: json, method: "GET"}),
	add: async (data: any) => await FetchInterceptor(url(""), {body: JSON.stringify(data), headers: json, method: "POST"}),
	update: async (id: number, data: any) => await FetchInterceptor(url(`/${id}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	remove: async (id: number) => await FetchInterceptor(url(`/${id}`), {headers: json, method: "DELETE"}),
	/** Returns empty cells too, so the admin can show what hasn't been priced. */
	getGrid: async (id: number, seatingChartId?: number) =>
		await FetchInterceptor(url(`/${id}/Grid${seatingChartId ? `?seatingChartId=${seatingChartId}` : ""}`), {headers: json, method: "GET"}),
	/** Batched — a club edits a column at a time. */
	saveGrid: async (id: number, cells: any[]) => await FetchInterceptor(url(`/${id}/Grid`), {body: JSON.stringify(cells), headers: json, method: "POST"}),
	copyFrom: async (id: number, sourceId: number) => await FetchInterceptor(url(`/${id}/CopyFrom/${sourceId}`), {headers: json, method: "POST"})
}
